// src/components/Footer.js
import React from 'react';

export default function Footer() {
  return (
    <footer className="footer-gym py-5">
      <div className="container">
        <div className="row g-4 g-lg-5 align-items-start">
          <div className="col-12 col-lg-4 text-lg-start">
            <h3 className="h6 fw-bold text-uppercase mb-3">Quantum Gym</h3>
            <p className="small mb-0">© 2026 Quantum Gym. All rights reserved.</p>
          </div>
          <div className="col-12 col-lg-4 text-center">
            <h3 className="h6 fw-bold text-uppercase mb-3">Contact</h3>
            <p className="small mb-2">
              Email:{' '}
              <a href="mailto:quantum.gym@outlook.com">quantum.gym@outlook.com</a>
            </p>
            <p className="small mb-0">Phone: +357 22777724</p>
          </div>
          <div className="col-12 col-lg-4 text-lg-end">
            <h3 className="h6 fw-bold text-uppercase mb-3">Follow Us</h3>
            <ul className="list-unstyled mb-0">
              <li className="mb-2">
                <a
                  href="https://facebook.com/quantumgym"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa-brands fa-facebook-f me-2" aria-hidden="true" />
                  Facebook
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="https://instagram.com/quantumgym"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa-brands fa-instagram me-2" aria-hidden="true" />
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://www.tiktok.com/@quantumgym"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa-brands fa-tiktok me-2" aria-hidden="true" />
                  TikTok
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
